import { getLanguageCode } from "./getURLParams";

export function countryCode () {
    const langPrefix = (getLanguageCode("Atd"))

    let countryCode = '';

    switch(langPrefix) {
        case 'de':
          countryCode = 'DE'
          break;

        case 'au':
          countryCode = 'AU'
        break;

        case 'us':
          countryCode = 'US'
          break;

        case 'en-nl':
          countryCode = 'NL'
          break;

        case 'en-ie':
          countryCode = 'IE'
          break;

        default:
          countryCode = "GB"
      return countryCode;
    }
return countryCode;
}